import React from "react";
import { HTMLAttributes, MouseEvent } from "react";

import "../tab.css";

interface ITabControlProps extends HTMLAttributes<HTMLDivElement> {
    headers: string[];
    defaultSelectedIndex?: number;
    selectedIndex?: number;
    disabled?: boolean;

    onTabChanged?: (index: number) => void;
}

interface ITabControlState {
    selectedIndex: number;
}

class TabControl extends React.Component<ITabControlProps, ITabControlState> {
    private tabBarRef: React.RefObject<HTMLElement>;

    constructor(props: Readonly<ITabControlProps>) {
        super(props);

        this.state = {
            selectedIndex: this.props.defaultSelectedIndex || 0
        };

        this.handleTabClick = this.handleTabClick.bind(this);
        this.selectTab = this.selectTab.bind(this);

        this.tabBarRef = React.createRef();
    }

    public componentDidUpdate(prevProps: Readonly<ITabControlProps>, prevState: Readonly<ITabControlState>) {
        if (this.props.selectedIndex !== prevProps.selectedIndex && this.props.selectedIndex !== undefined) {
            // Select new tab
        }
        else if (prevProps.defaultSelectedIndex !== this.props.defaultSelectedIndex && this.props.defaultSelectedIndex !== undefined) {
            // Select new default index
            this.selectTab(this.props.defaultSelectedIndex);
        }
    }

    public render() {
        const { headers, defaultSelectedIndex, className, disabled, onTabChanged, selectedIndex, ...props } = this.props;
        const selectedIndexReal = this.props.selectedIndex !== undefined ? this.props.selectedIndex : this.state.selectedIndex;

        return (
            <div className={`tab-root ${className ? className : ""} ${disabled ? "tab-disabled" : ""}`} {...props}>
                <header ref={this.tabBarRef} className="tab-bar">
                    {this.props.headers.map((h, i) => <button type="button" key={h} tabIndex={0} className={i === selectedIndexReal ? "tab-selected" : ""} onClick={this.handleTabClick}>{h}</button>)}
                </header>
                {React.Children.map(this.props.children, (c, i) => i === selectedIndexReal ? c : null)}
            </div>
        );
    }

    private handleTabClick(e: MouseEvent<HTMLSpanElement>) {
        if (!e.currentTarget.parentElement || this.props.disabled === true) {
            return;
        }

        let clickedIndex = -1;
        for (let i = 0; i < e.currentTarget.parentElement.children.length; i++) {
            if (e.currentTarget.parentElement.children[i] === e.currentTarget) {
                clickedIndex = i;
                break;
            }
        }

        if (clickedIndex < 0) {
            return;
        }

        this.selectTab(clickedIndex);
    }

    private selectTab(index: number) {
        if (this.tabBarRef.current) {
            // Scroll selected tab into view
            const innerLeft = (this.tabBarRef.current.children[index] as HTMLElement).offsetLeft - this.tabBarRef.current.offsetLeft;
            this.tabBarRef.current.scrollLeft = innerLeft;
        }

        if (this.props.onTabChanged) {
            this.props.onTabChanged(index);
        }

        this.setState({
            selectedIndex: index
        });
    }
}

export default TabControl;
